export enum CompanyId {
  Natura = 1,
  Avon = 2,
}
